import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { HOME_HEALTH_CASES_PATH } from "../ExperimentalHomeHealth/Cases/paths";
import { HomeHealthProtectedCasesPage } from "../ExperimentalHomeHealth/Cases/ProtectedCasesPage";
import { HOME_HEALTH_VISIT_VERIFICATION_PATH } from "../ExperimentalHomeHealth/VisitVerification/paths";
import { HomeHealthProtectedVisitVerificationPage } from "../ExperimentalHomeHealth/VisitVerification/ProtectedVisitVerificationPage";
import { HelpCenterPage } from "../HelpCenter/Page";
import { HELP_CENTER_PATH } from "../HelpCenter/paths";
import { NotFoundPage } from "../lib";

export function AppV2PrivateRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/${HOME_HEALTH_CASES_PATH}`}>
        <HomeHealthProtectedCasesPage />
      </Route>
      <Route exact path={`${match.url}/${HOME_HEALTH_VISIT_VERIFICATION_PATH}`}>
        <HomeHealthProtectedVisitVerificationPage />
      </Route>
      <Route exact path={`${match.url}/${HELP_CENTER_PATH}`}>
        <HelpCenterPage />
      </Route>
      <Route exact path={match.url}>
        <div>This is a private route from appV2</div>
      </Route>
      <Route path="*">
        <NotFoundPage />
      </Route>
    </Switch>
  );
}
